import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type HeaderAppearanceState = {
    useColouredHeader: boolean
    setUseColouredHeader: (useColoured: boolean) => void
    toggleUseColouredHeader: () => void
}

export const useHeaderAppearanceStore = create<HeaderAppearanceState>()(
    persist(
        (set, get) => ({
            useColouredHeader: true,
            setUseColouredHeader: (useColoured) => set({ useColouredHeader: useColoured }),
            toggleUseColouredHeader: () => set({ useColouredHeader: !get().useColouredHeader }),
        }),
        { name: 'header-appearance-preference' }
    )
)
